import { motion } from 'framer-motion'
import React, { useEffect, useRef, useState } from 'react'
import styled from 'styled-components'
import gsap from 'gsap';
import { Link } from 'react-router-dom';

const ExtraProject = () => {
    const [selectPic, setselectPic] = useState({ active: false, index: true });
    const [btnActive, setBtnActive] = useState(false)
    const projectCont = useRef(null);

    const Boxes = [
        {
            name: 'Learn Space',
            type: 'Web Development',
            src: "/swiper/learn.png"
        },
        {
            name: 'Anime-Valley',
            type: 'Web Development & Design',
            src: "/swiper/anime.png"
        },
        {
            name: 'Ecommerce',
            type: 'Web Development & Design',
            src: '/swiper/mern1.png'
        },
        {
            name: 'Portfolio',
            type: 'Web Development & Design',
            src: '/swiper/port1.png'
        },
    ]
    const variants = {
        default: {
            scale: 0,
            x: "-50%",
            y: "-50%",
            transition: { ease: [0.76, 0, 0.24, 1] }
        },

        show: {
            scale: 1,
            x: "-50%",
            y: "-50%",
            transition: { ease: [0.76, 0, 0.24, 1] }
        },
        exit: {
            scale: 0,
            x: "-50%",
            y: "-50%",
            transition: { ease: [0.76, 0, 0.24, 1] }
        }
    }

    const ExtraprojectVariant = {
        initial: {
            opacity: 0,
            y: 100
        },

        animate: {
            opacity: 1,
            y: 0,
            transition: {
                delay: 0.2,
                ease: [0.65, 0, 0.35, 1]
            }
        }
    }


    useEffect(() => {
        const moveContainerX = gsap.quickTo(projectCont.current, "left", { duration: 0.5, ease: "power3" })
        const moveContainerY = gsap.quickTo(projectCont.current, "top", { duration: 0.5, ease: "power3" })

        window.addEventListener("mousemove", (e) => {
            moveContainerX(e.clientX);
            moveContainerY(e.clientY);
        })

        // eslint-disable-next-line
    }, [])



    return (
        <ExtraDiv className='extraDiv'>
            <div className="content" >
                {
                    Boxes.map((box, index) => (
                        <ExtraBox
                            variants={ExtraprojectVariant}
                            initial="initial"
                            whileInView="animate"
                            onMouseEnter={() => setselectPic({ active: true, index: index })}
                            onMouseLeave={() => setselectPic({ active: false, index: index })}
                            className='extraBox' key={index} >

                            <div
                                className="name">
                                {box.name}
                            </div>

                            <div
                                className="type">
                                {box.type}
                            </div>
                        </ExtraBox>
                    ))
                }
            </div>

            <motion.div className="workButton"
                onHoverStart={() => setBtnActive(!btnActive)}
                onHoverEnd={() => setBtnActive(!btnActive)}
            >

                <motion.div
                    animate={{ top: btnActive ? "-100%" : "0" }}
                    transition={{ duration: 0.5, ease: [0.83, 0, 0.17, 1] }}
                    className="slider"
                >

                    <div className="btnWrk">
                        <Link to={"/work"}>
                            My Projects
                        </Link>
                    </div>
                    <div className="btnWrk">
                        <Link to={"/work"}>
                            My Projects
                        </Link>
                    </div>

                </motion.div>

            </motion.div>


            <ProjectImg
                ref={projectCont}
                variants={variants}
                initial={"default"}
                animate={selectPic.active ? 'show' : 'exit'}
            >
                <div className="projectSlider" style={{ top: selectPic.index * -100 + "%" }}  >
                    {Boxes.map((box, index) => (
                        <div className='boxImg' key={index}>
                            <img src={box.src} alt="boxImg" key={index} />
                        </div>
                    ))}
                </div>
            </ProjectImg>
        </ExtraDiv>
    )
}

export default ExtraProject

const ProjectImg = styled(motion.div)`
    position: absolute;
    width: 30rem;
    pointer-events: none;
    height: 20rem; 
    display: flex;
    justify-content: center;
    align-item: center;
    overflow: hidden;
    background: var(--black3);
    border-radius: 1rem;
    
    @media only screen and (max-width: 480px) {
        width: 25rem !important;
        height: 15rem !important;
    }
    
    .projectSlider{
        height: 100%;
        position: absolute;
        transition: top 0.5s (0.76,0,0.24,1);
    }

    .boxImg{
        height: 20rem;
        width: 25rem;
        position: relative;
        
        @media only screen and (max-width: 480px) {
            width: 25rem !important;
            height: 15rem !important;
        }
        img{
            border-radius: 1rem;
            height: 100%;
            width: 100%;
            object-fit: contain;
        }
    }
`

const ExtraBox = styled(motion.div)`
    display: flex;
    width: 100%;
    cursor: none;
    padding: 3rem 0;
    align-items: center;
    position: relative;
    border-top: 1px solid rgba(255, 255, 255, 0.2);
    overflow: hidden;
    
    &:last-child{
        border-bottom: 1px solid rgba(255, 255, 255, 0.2);
    }

    @media only screen and (max-width: 780px) {
        .type{
            font-size: 0.8rem !important;
        }
    }


    
    &:hover{
        
        .name{
            transform : translateX(-15px);
            opacity: 0.4;
        }
        
        .type{
            transform : translateX(15px);
        }
    }
    
    .name{
        position: relative;
        flex: 0.7;
        padding-left: 3rem;
        font-family: var(--font5);
        font-size: 6rem;
        position: relative;
        transition: all 250ms ease-in-out;
        
        @media only screen and (max-width: 960px) {
            padding-left: 0rem !important;
            font-size: 5rem !important;
        }

        @media only screen and (max-width: 780px) {
            font-size: 4rem !important;
        }
        @media only screen and (max-width: 570px) {
            font-size: 3rem !important;
        }
    }
    
    .type{
        font-family: var(--font5);
        font-size: 1rem;
        opacity: 0.3;
        position: relative;
        flex: 0.3;
        transition: all 250ms ease-in-out;
    }
`

const ExtraDiv = styled.div`
    min-height: 100vh;
    margin-top: 50vh;
    position: relative;
    background: var(--blackLight);
    width: 100vw;
    transform: translate(-5%);
    display: flex;
    justify-content:center;
    align-items: center;
    gap: 5vh;
    flex-direction: column;


    .content{
        width: 90%;
        display: flex;
        height: 100%;
        flex-direction:column;
        padding: 20vh 5rem;
        cursor: none;
        gap: 1rem;
        overflow: hidden;

        div:first-child{
            .name{
                @media only screen and (max-width: 570px) {
                    font-size: 2.25rem !important;
                }            
            }
        }

        @media only screen and (max-width: 960px) {
            padding: 2rem !important;
        }
    }

    @media only screen and (max-width: 780px) {
        margin-top: 20vh;

        .content{
            padding: 10vh 2rem !important;
        }
            
    }
`